import * as Sentry from "@sentry/react";
import {FC} from "react";
import {App, Button, Form, FormProps, Input} from "antd";

type FormType = {
    content: string;
}

export const FeedbackForm: FC = () => {
    const { message } = App.useApp();

    const handleSend: FormProps<FormType>['onFinish'] = ({ content }) => {
        Sentry.captureException(`Feedback error: ${content}`);
        void message.success('Сообщение отправлено');
    }

    return (
        <Form<FormType>
            onFinish={handleSend}
        >
            <Form.Item<FormType> name="content" rules={[{ required: true }]}>
                <Input.TextArea rows={3} placeholder="Дополнительная информация" />
            </Form.Item>
            <Form.Item<FormType> noStyle>
                <Button type="primary" htmlType="submit">Отправить</Button>
            </Form.Item>
        </Form>
    )
}